import { Grid, makeStyles, Paper, Button, Link } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { useAPI } from "../../../common/API";
import DeterminateLinearProgress from "../../../utils/DeterminateLinearProgress";

const useEmailRuleStyles = makeStyles((theme) => ({
    disabled: {
        backgroundColor: theme.palette.action.hover,
    },
    root: {
        transition: theme.transitions.create("background-color", {
            duration: "300ms",
        }),
        marginBottom: 15,
    },
    row: {
        paddingLeft: 15,
        paddingRight: 15,
        marginBottom: 10,
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center",
    },
    toolbar: {
        paddingLeft: 15,
        paddingRight: 15,
    },
}));

export default function GmailAPIToken(props) {
    const userAuth = props.userAuth;
    const api = useAPI();
    const classes = useEmailRuleStyles();
    const [accNumber, setAccNumber] = useState(props.accountNumber);
    const respStatus = props.respStatus;
    const [sendingReq, setSendingReq] = useState(false);

    const update = (token, accNum) => {
        props.setOpenSnackbar(false);
        setSendingReq(true);
        return props.onChange(token, accNum);
    };

    useEffect(() => {
        if (respStatus) {
            setSendingReq(false);
            props.setRespStatus(null);
        }
    }, [respStatus]);

    useEffect(() => {
        setAccNumber(props.accountNumber);
    }, [props.accountNumber]);

    const deleteOAuthToken = () => {
        setSendingReq(true);
        // Use the new revoke token endpoint
        api.post(`api/v1/auth/user/revoke-token/`, {
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => {
                if (res) {
                    props.setRespStatus(res.status);
                    if (res.ok) {
                        return res.json();
                    }
                }
            })
            .then((data) => {
                if (data && data.success) {
                    props.onChange(""); // Clear the token in UI
                }
            })
            .catch((error) => {
                console.error('Error revoking token:', error);
                props.setRespStatus(500);
            });
    };
    const onAddClick = () => update(props.userAuth, accNumber);

    return (
        <Paper className={classes.root}>
            <DeterminateLinearProgress visible={sendingReq} opened={true} />
            <Toolbar className={classes.toolbar}>
                <Grid
                    container
                    direction="row"
                    justify="space-between"
                    component="label"
                >
                    <Typography variant="h6" component="div">
                        Gmail Settings
                    </Typography>
                </Grid>
            </Toolbar>
            <Grid
                container
                direction="row"
                spacing={3}
                justify="space-around"
                className={classes.row}
            >
                <Grid
                    container
                    direction="row"
                    spacing={3}
                    justify="space-around"
                    className={classes.row}
                >
                    {/* Google requires this disclosure to immediately precede the
                        consent request — see GOOGLE_OAUTH_VERIFICATION.md 1.4. */}
                    {!userAuth && (
                        <Grid item xs={12}>
                            <Typography variant="body2" color="textSecondary">
                                When you click &ldquo;Get Token&rdquo;, Google will ask you to
                                give EzRespond access to your Gmail. EzRespond uses
                                it to read incoming mail to find marketplace buyer
                                messages, send replies from your templates, and
                                label answered threads. We keep subject lines,
                                email addresses and thread IDs so no one gets
                                answered twice. We never store email bodies, and
                                you can revoke access at any time.{" "}
                                <Link
                                    href="https://ezrespond.com/privacy-policy/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Privacy Policy
                                </Link>
                            </Typography>
                        </Grid>
                    )}
                    <Grid item xs={6}>
                        <Typography>API Token</Typography>
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: "end" }}>
                        {userAuth ? (
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={deleteOAuthToken}
                            >
                                Delete Token
                            </Button>
                        ) : (
                            <Button
                                label="API Token"
                                variant="contained"
                                color="primary"
                                href={props.oauthUrl}
                                onClick={onAddClick}
                            >
                                Get Token
                            </Button>
                        )}
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: "end" }}></Grid>
                </Grid>
            </Grid>
        </Paper>
    );
}
